import { OP } from "../../constant";

// Account list
export function fetchAccountRequest(token) {
  return {
    type: OP.ACCOUNT_LIST_REQUEST,
    payload: {
      token,
    },
  };
}

export function fetchAccountReset() {
  return {
    type: OP.ACCOUNT_LIST_RESET,
  };
}

//add Account
export function createAccountRequest(token, data) {
  return {
    type: OP.CREATE_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function createAccountReset() {
  return {
    type: OP.CREATE_ACCOUNT_RESET,
  };
}

//view Account
export function viewAccountRequest(token, data) {
  return {
    type: OP.VIEW_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewAccountReset() {
  return {
    type: OP.VIEW_ACCOUNT_RESET,
  };
}

// get partner Account details
export function getPartnerAccountRequest(token, data) {
  return {
    type: OP.GET_PARTNER_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getPartnerAccountReset() {
  return {
    type: OP.GET_PARTNER_ACCOUNT_RESET,
  };
}

//activate Account
export function activateAccountRequest(token, data) {
  return {
    type: OP.ACTIVATE_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function activateAccountReset() {
  return {
    type: OP.ACTIVATE_ACCOUNT_RESET,
  };
}

//deactivate Account
export function deactivateAccountRequest(token, data) {
  return {
    type: OP.DEACTIVATE_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deactivateAccountReset() {
  return {
    type: OP.DEACTIVATE_ACCOUNT_RESET,
  };
}

// approve agent
export function approveAccountRequest(token, data) {
  return {
    type: OP.APPROVE_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function approveAccountReset() {
  return {
    type: OP.APPROVE_ACCOUNT_RESET,
  };
}

// reject agent
export function rejectAccountRequest(token, data) {
  return {
    type: OP.REJECT_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function rejectAccountReset() {
  return {
    type: OP.REJECT_ACCOUNT_RESET,
  };
}

//create partner Account
export function createPartnerAccountRequest(token, data) {
  return {
    type: OP.CREATE_PARTNER_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function createPartnerAccountReset() {
  return {
    type: OP.CREATE_PARTNER_ACCOUNT_RESET,
  };
}

//view partner Account
export function viewPartnerAccountRequest(token, data) {
  return {
    type: OP.VIEW_PARTNER_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewPartnerAccountReset() {
  return {
    type: OP.VIEW_PARTNER_ACCOUNT_RESET,
  };
}

//view agent Account
export function viewAgentAccountRequest(token, data) {
  return {
    type: OP.VIEW_AGENT_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewAgentAccountReset() {
  return {
    type: OP.VIEW_AGENT_ACCOUNT_RESET,
  };
}

// get wakala account details
export function getWakalaAccountDetailsRequest(token, data) {
  return {
    type: OP.GET_WAKALA_ACCOUNT_DETAILS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getWakalaAccountDetailsReset() {
  return {
    type: OP.GET_WAKALA_ACCOUNT_DETAILS_RESET,
  };
}
